<template>
    <div v-show="visible" :style="{top: y+'px', left: x+'px'}" class="video-share-menu">
        <button class="share-item" type="button" v-on:click="copy">
            <span class="uk-margin-small-right" uk-icon="icon: link"/>
            {{ copied ? $t('linkCopied') : $t('copyVideoLink') }}
        </button>
    </div>
</template>


<script>

const MENU_WIDTH = 230;
const MENU_HEIGHT = 44;

function writeWithSelection(text) {
    let field = document.createElement('textarea');
    field.value = text;
    field.setAttribute('readonly', '');
    field.style.position = 'fixed';
    field.style.opacity = '0';

    document.body.appendChild(field);
    field.select();

    let copied = false;
    try {
        copied = document.execCommand('copy');
    } catch (error) {
        copied = false;
    }

    document.body.removeChild(field);

    return copied ? Promise.resolve() : Promise.reject();
}

export default {
    name: 'VideoShareMenu',
    data() {
        return {
            visible: false,
            copied: false,
            anchor: '',
            x: 0,
            y: 0,
        };
    },
    mounted() {
        document.addEventListener('contextmenu', this.openMenu);
        document.addEventListener('click', this.closeOnOutside);
        document.addEventListener('keydown', this.closeOnEscape);
        window.addEventListener('scroll', this.hide, true);
        window.addEventListener('resize', this.hide);
    },
    beforeDestroy() {
        document.removeEventListener('contextmenu', this.openMenu);
        document.removeEventListener('click', this.closeOnOutside);
        document.removeEventListener('keydown', this.closeOnEscape);
        window.removeEventListener('scroll', this.hide, true);
        window.removeEventListener('resize', this.hide);
    },
    methods: {
        openMenu(event) {
            let trigger = event.target.closest ? event.target.closest('[data-video-anchor]') : null;

            if (!trigger) {
                this.hide();
                return;
            }

            event.preventDefault();

            this.anchor = trigger.getAttribute('data-video-anchor');
            this.copied = false;
            this.x = Math.min(event.clientX, window.innerWidth - MENU_WIDTH - 10);
            this.y = Math.min(event.clientY, window.innerHeight - MENU_HEIGHT - 10);
            this.visible = true;
        },
        copy() {
            let self = this;

            this.write(window.location.origin + this.$route.path + '#' + this.anchor).then(function () {
                self.copied = true;
                setTimeout(function () {
                    self.hide();
                }, 900);

            }).catch(function () {
                self.hide();
            });
        },
        // navigator.clipboard is unavailable without a secure context and can be
        // denied outright, so keep the execCommand path as a fallback.
        write(text) {
            if (navigator.clipboard) {
                return navigator.clipboard.writeText(text).catch(function () {
                    return writeWithSelection(text);
                });
            }

            return writeWithSelection(text);
        },
        closeOnOutside(event) {
            if (this.$el.contains(event.target)) {
                return;
            }

            this.hide();
        },
        closeOnEscape(event) {
            if (event.key === 'Escape') {
                this.hide();
            }
        },
        hide() {
            this.visible = false;
        },
    },
}

</script>


<style lang="scss" scoped>

.video-share-menu {
    position: fixed;
    z-index: 1200;
    background: $alternative-color;
    border-radius: $border-radius;
    box-shadow: 0 5px 15px rgba(0, 0, 0, 0.4);
    padding: 4px;
    min-width: 230px;
}

.share-item {
    display: block;
    width: 100%;
    padding: 8px 12px;
    border: none;
    border-radius: $border-radius;
    background: transparent;
    color: $font-color;
    font-size: $site-font-size-small;
    text-align: left;
    cursor: pointer;

    &:hover {
        background: rgba(255, 255, 255, 0.08);
        color: $font-color-hover;
    }
}

</style>
